import { Coordinate, Location, TileSize } from "game-common/models"

interface StairSprite {
    x: number; y: number; rotation: number
    scale: { set(x: number, y: number): void }
}

/** Up artwork opens to the left; down artwork opens to the right. Mirror their
 * entrance toward the local safe spot, then turn north/south exits around the cell. */
export const applyStairOrientation = (sprite: StairSprite, at: Coordinate, type: string, exit?: Location): void => {
    if (!exit || (type !== "stairs-up" && type !== "stairs-down")) return
    const dx = exit.x - (at.x + .5) * TileSize, dy = exit.y - (at.y + .5) * TileSize
    const horizontal = Math.abs(dx) >= Math.abs(dy)
    const left = horizontal && dx < 0
    const flip = (type === "stairs-up") !== left
    const rotation = horizontal ? 0 : dy < 0 ? -Math.PI / 2 : Math.PI / 2
    const sx = flip ? -1 : 1
    const cos = Math.round(Math.cos(rotation)), sin = Math.round(Math.sin(rotation))
    const corners = [[0, 0], [sx * TileSize, 0], [0, TileSize], [sx * TileSize, TileSize]]
    sprite.scale.set(sx, 1)
    sprite.rotation = rotation
    sprite.x = at.x * TileSize - Math.min(...corners.map(([x, y]) => x * cos - y * sin))
    sprite.y = at.y * TileSize - Math.min(...corners.map(([x, y]) => x * sin + y * cos))
}
